import { createApp, defineAsyncComponent } from "vue";
import router from "./router";
import App from "./App.vue";
// import Toast from "vue-toastification";
// Import the CSS or use your own!
// import "vue-toastification/dist/index.css";
import VueObserveVisibility from "vue-observe-visibility";

import { Form, Field, ErrorMessage } from "vee-validate";

import "./vee-validate-config.js";

// import SvgIcon from "@/components/svgIcon";
import SvgIcon from "@/components/SvgIconNew.vue";
import SvgIconCustom from "./components/SvgIconCustom.vue";
import InlineSvg from "vue-inline-svg";
import AccessErrorState from "@/components/AccessErrorState.vue";

import "vue-multiselect/dist/vue-multiselect.css";
import "@starline-security/component-library/dist/component-library.css";

import "./index.css";
// to make the app css; put component-library.css first adn index.css second
import store from "@/store";
import { _ } from "lodash";
import * as Sentry from "@sentry/vue";

window._ = _;
// import BaseModal from "@/components/BaseComponents/BaseModal.vue";
const BaseModal = defineAsyncComponent(() =>
  import("@/components/BaseComponents/BaseModal.vue")
);
import moment from "moment-timezone";

moment.tz.setDefault("Australia/Brisbane");

const app = createApp(App);
app.use(VueObserveVisibility);
app.use(router);
app.use(store);
// app.use(Toast, {
//   position: "bottom-right",
//   transition: "Vue-Toastification__fade",
// });

app.config.globalProperties.append = (path, pathToAppend) =>
  path + (path.endsWith("/") ? "" : "/") + pathToAppend;

app.config.globalProperties.$filters = {
  price(value) {
    return Number(value || 0)
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  formatDate(value, format) {
    let f = "DD MMM YYYY";
    if (format === "short") f = "DD/MM/YY";
    if (format === "date-time") f = "DD/MM/YY h:mm a";
    if (value) {
      return moment.utc(value).format(f);
    }
  },
  changePriceForm(price) {
    if (price !== undefined) {
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
      return 0;
    }
  },
};

app.component("BaseModal", BaseModal);
app.component("VForm", Form);
app.component("VField", Field);
app.component("ErrorMessage", ErrorMessage);
app.component("SvgIcon", SvgIcon);
app.component("InlineSvg", InlineSvg);
app.component("CustomSvg", SvgIconCustom);
app.component("AccessErrorState", AccessErrorState);

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/[a-z0-9-]+\.api\.icp\.systems\/api/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

app.mount("#app");
